import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
import { selectDeviceType } from '../../../Redux/selectors';
// ##### 25-05-21 Komarov
import HomeIcon from '../Icons/homeicon';
import LocalizationNavLink from '../Localization/LocalizationNavLink';
// ##### 23-11-01 Komarov
import parse from 'html-react-parser';
import { Media } from '../../../helpers/MediaConfig';
import { RELATIVE_Z2001 } from '../Icons/iconStyles';

// ##### Komarov 2025-07-14
const HomeLinkTag = () => {
  const deviceType = useSelector(selectDeviceType);
  // ##### Komarov 2025-08-05
  const hintText = useLocalizedText('Home_icon');

  return (
    <LocalizationNavLink exact to={''}>
      {
        // ##### 23-04-24 Komarov
        deviceType === 'tablet' ? (
          <HomeIcon hintText={parse(hintText)} />
        ) : (
          <>
            {/* ##### 25-01-16 Komarov */}
            <Media
              greaterThanOrEqual="Laptop-1024-1440"
              style={RELATIVE_Z2001}
            >
              <HomeIcon hintText={parse(hintText)} />
            </Media>
            <Media lessThan="Laptop-1024-1440">
              <HomeIcon hintText={parse(hintText)} />
            </Media>
          </>
        )
      }
    </LocalizationNavLink>
  );
};

// ##### 25-05-21 Komarov
export default HomeLinkTag;
